import LabelDropdown from "../../components/LabelDropdown";
import { IoIosMore } from "react-icons/io";

const Setup = () => {
  const dropdownData = [
    {
      label: "Torque",
      options: ["Newton-meter [N-m]", "Other Units"],
      defaultValue: "Select Torque",
    },
    {
      label: "Thrust",
      options: ["Kilogram-force [kgf]", "Other Units"],
      defaultValue: "Select Thrust",
    },
    {
      label: "Current",
      options: ["Ampere [A]", "Other Units"],
      defaultValue: "Select Current",
    },
    {
      label: "Motor Speed",
      options: ["Newton-meter [N-m]", "Other Units"],
      defaultValue: "Select Motor Speed",
    },
    {
      label: "Weight",
      options: ["Gram [g]", "Other Units"],
      defaultValue: "Select Weight",
    },
    {
      label: "Temperature",
      options: ["Celcius [°C]", "Other Units"],
      defaultValue: "Select Temperature ",
    },
  ];

  // const plotLabels = [
  //   { label: "Acc", color: "#FFC6C6" },
  //   { label: "Torque", color: "#FFC6C6" },
  //   { label: "RPM", color: "#FFC6C6" },
  //   { label: "Current", color: "#FFC6C6" },
  //   { label: "PWM", color: "#FFC6C6" },
  //   { label: "Temperature", color: "#FFC6C6" },
  // ];

  return (
    <div className="flex flex-col min-h-screen">
      {/* Setup Section */}
      <div className="flex flex-col p-6 flex-shrink-0">
        {/* Setup Header */}
        <div className="mb-6">
          <p className="text-2xl text-[#EEEEEE] font-medium">Setup</p>
        </div>

        {/* Working Units and Working Directory */}
        <div className="grid grid-cols-6">
          <div className="col-span-4">
            <div className="mb-6">
              <p className="text-[#EEEEEE] text-xl font-light border-b-[1px] border-gray-600">
                Working Units
              </p>
              <div className="mt-4 w-[60%] space-y-4 ">
                {dropdownData.map((item, index) => (
                  <LabelDropdown
                    key={index}
                    label={item.label}
                    options={item.options}
                    defaultValue={item.defaultValue}
                  />
                ))}
              </div>
            </div>
            <div className="mb-6">
              <p className="text-xl text-[#EEEEEE] font-light border-b-[1px] border-gray-600">
                Working Directory
              </p>
              <div className="flex items-center justify-between mt-2">
                <p className="text-[#EEEEEE] font-extralight">
                  Please choose where log files will be saved.
                </p>
                <button className="p-1 border-[1px] rounded border-[#EEEEEE] hover:bg-[#EEEEEE] duration-300 hover:text-black text-[#EEEEEE]">
                  <IoIosMore className="text-xl " />
                </button>
              </div>
            </div>
            <div className="mt-12 flex items-center justify-start gap-x-4">
              <button className="border-[1px] border-[#EEEEEE] px-8 py-1 rounded hover:bg-[#EEEEEE] hover:text-black text-[#EEEEEE] duration-300">
                Backup
              </button>
              <button className="border-[1px] border-[#EEEEEE] px-8 py-1 rounded hover:bg-[#EEEEEE] hover:text-black text-[#EEEEEE] duration-300">
                Restore
              </button>
              <button className="border-2 border-[#306AF6] px-8 py-1 rounded bg-[#306AF6] text-white hover:bg-[#1F316F] hover:border-[#1F316F] duration-300">
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Graphs and Stats Section */}
      {/* <div className="border-b-4 border-[#0E6573]"></div>

      <div className="flex-grow bg-[#D9D9D9]">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <h1 className="text-xl font-bold">Real Time Plots</h1>
            <div className="flex gap-6 items-center justify-center">
              <h4 className="text-[#EEEEEE] text-xl font-semibold text-nowrap">
                Plots Refresh Rate
              </h4>
              <select className="w-full px-2 bg-transparent text-[#EEEEEE] rounded border-2">
                <option value="">Refresh Rate</option>
                <option value="com1">40 Hz</option>
                <option value="com2">60 Hz</option>
              </select>
            </div>
          </div>

          <div className="flex items-center justify-start gap-2 mt-4">
            {plotLabels.map((item, index) => (
              <BadgeLabel key={index} color={item.color} label={item.label} />
            ))}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default Setup;
